import { Modal } from "reactstrap"
import styles from "./RequestChange.module.scss"
import { BsFillExclamationCircleFill } from "react-icons/bs"
import { Field, Form } from "react-final-form";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import OutlinedFormInput from "../../../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import { onBlurFormatNumber, parseNumberForDB } from "../../../../../components/functions/utilities";
import { formActionTypes, SalesMarketingSectionTypes } from "../../../../../interfaces/interfaces";
import { RestS } from "../../../../../rest/rest-service";

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  initialValues: any;
  sectionType?: SalesMarketingSectionTypes;
  handleChange?: Function;
}

const RequestChange = ({ isOpen, setIsOpen, initialValues, sectionType, handleChange }: Props) => {
  const submitForm = (values) => {
    const obj = {
      ...initialValues,
      isUserAltered: true,
      currMonthValue: values.value,
      changeReason: values.changeReason,
    }
    console.log("Request Change Submitted", obj);
    RestS.sendSupportMessage(`Request Change for ${sectionType} - ${obj.label} from value: ₹${parseFloat(initialValues?.currMonthValue)?.toLocaleString('en-IN')} to ₹${parseFloat(obj?.currMonthValue)?.toLocaleString('en-IN')} and reason: ${obj.changeReason}`, 'Sales and Marketing');
    handleChange(obj, sectionType, formActionTypes.edit);
    setIsOpen(false);
  }

  return (
    <Modal isOpen={isOpen} size='md' centered={true} className="requestChangeModal" contentClassName={styles.requestChangeContent}>
      <>
        <BsFillExclamationCircleFill />
        <h2>Request Change</h2>
        <Form
          initialValues={{ value: '', changeReason: '' }}
          validate={(values) => {
            return {}
          }}
          onSubmit={(values) => {
            submitForm(values);
          }} render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, mutators } }) => {
            return (
              <form onSubmit={handleSubmit} className={styles.deleteReasonForm}>
                <div className={styles.formBodyContainer}>
                  <Field
                    name="value"
                    validate={(value) => {
                      if (!value) {
                        return `Enter value`
                      }
                    }}
                  >
                    {(props) => (

                      <OutlinedFormInput
                        {...props.input}
                        inpuType="number"
                        label="Value"
                        name={props.input.name}
                        value={props.input.value}

                        allowDecimals={true}
                        onChange={(e) => {
                          const numericValue = parseNumberForDB(e.target.value, true);
                          // console.log('numeric value', numericValue)
                          props.input.onChange(numericValue);
                        }}
                        error={props.meta.error}
                        touched={props.meta.touched}
                        onBlur={(e) => {
                          const value = props.input.value;
                          console.log('value', value);
                          const formattedValue = onBlurFormatNumber(value, 2);
                          props.input.onChange(formattedValue);
                          props.input.onBlur(e);
                        }}
                        unitPlaceHolder='₹'
                        unitPosition="left"
                        placeholder="10,000,000"
                        isCurrency={true}
                      />
                    )}
                  </Field>
                  <Field
                    name="changeReason"
                    validate={(value) => {
                      if (!value) {
                        return `Enter reason`
                      }
                    }}
                  >
                    {(props) => (
                      <OutlinedFormInput
                        {...props.input}
                        label="Reason"
                        name="changeReason"
                        value={props.input.value}
                        onChange={props.input.onChange}
                        placeholder="Numbers don’t match internal report"
                        error={props.meta.error}
                        touched={props.meta.touched}
                        maxLength={200}
                      />

                    )}
                  </Field>
                </div>
                <div className={styles.footerContainer}>
                  <MeritoButton btnText="Cancel" isRounded={true} type="secondary-2" size="lg" onClick={() => setIsOpen(false)} />
                  <MeritoButton disabled={pristine || hasValidationErrors} btnText={"Submit Request"} isRounded={true} type="primary-1" size="lg" onClick={() => {
                    handleSubmit();
                  }} />
                </div>
              </form>
            )
          }} />
      </>
    </Modal>
  )
}

export default RequestChange